import { render } from "./ReportPod.vue?vue&type=template&id=3f7a0dd5"
import script from "./ReportPod.vue?vue&type=script&lang=js"
export * from "./ReportPod.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__